/**
 * DESERTLAND.Content.Plant
 */
import { Utils } from '../cals.utils';
import { App } from '../desertland.app';
import { ROUTES } from '../desertland.router';
import { AddThis } from '../cals.addthis';
import Swiper from 'swiper';
import 'kendo-ui-core';
// import 'kendo-ui-core/js/kendo.view';

/* tslint:disable variable-name prefer-for-of triple-equals */
declare var log, info, warn, groupCollapsed, groupEnd;


export class PlantContent {
  public page = ROUTES.PLANT;
  public container = "#tmpl_main_content";
  public tplSel = 'tpl-layout-plant';
  public gallerySel = '.plant-images-gallery';
  public datasource: any = {};
  public nid: number = -1;
  public returnUrl = "";

  public plantSwiper: any;

  public init(options) {
    groupCollapsed("Plant.init");
    info("plant.init options:", options);
    this.nid = -1;
    if (options && options.id) {
      this.nid = options.id;
    }
    if (options && typeof options.suffix === "string") {
      let suffixTest = "ideas/";
      if (options.suffix.substring(0, suffixTest.length) === suffixTest) {
        this.returnUrl = options.suffix;
      } else {
        this.returnUrl = "";
      }
    } else {
      this.returnUrl = "";
    }

    //this.model = {};

    if (this.nid > 0) {

      if (Utils.isEmpty(this.datasource)) {
        // log("no datasource yet");
        if (App.plants && App.plants.datasource && typeof App.plants.datasource.filter === "function") {
          log("using Plants datasource");
          this.datasource = App.plants.datasource;
          this.filterPlant(this.datasource, this.loadRenderTpl);
        } else {
          log("get new datasource");
          App.plants.getNewDataSource((ds) => {
            // info(ds);
            this.datasource = ds;
            this.filterPlant(ds, this.loadRenderTpl);
          });
        }
      } else {
        log("// we already have datasource ");
        this.filterPlant(this.datasource, this.loadRenderTpl);
      }
    } else {
      info("nid < 0 --> do?");
    }

    // this.loadContent(this.formatThenRender);
    groupEnd("Plant.init");
  }

  public filterPlant(ds, next) {
    // log(this.nid, ds);

    // avoid Kendo Error: Uncaught Error: Cannot call method 'value' of kendoDropDownList before it is initialized
    App.plants.destroyPager();

    ds.filter({ field: "nid", operator: "eq", value: this.nid });
    
    let view = ds.view();

    // log(view.length);

    if (view && view.length > 0) {

      // log(view[0].common_name);

      //this.model = view[0];
      App.models.plant = view[0];
      // this.data = this.model.toJSON();
      // log(this.data);

      // App.models.plant = kendo.observable({
      //     data: [
      //         new Plant(view[0])
      //     ]
      // });


      this.getDeets(next);

    } else {
      info("data not found", this.nid);
    }
  }

  public getDeets(next) {
    log("Plant > getDeets, extend data", this.nid);
    //log(App.models.plant);

    let me = this;
    let callback = (data) => {
      next(this.mergeDeets(data), me);
    };

    App.service.load.plant(callback, this.nid);

  }


  public mergeDeets(data) {

    //$.extend( object1, object2 );
    //log(data[0].nid);
    //log(DESERTLAND.models.plant.get("nid"));
    if (data && data.length > 0 && data[0].nid && data[0].nid == App.models.plant.get("nid")) { // eslint-disable-line eqeqeq
      let p = data[0];
      //info("mergeDeets",p);
      $.extend(App.models.plant, p);
      //info(DESERTLAND.models.plant);

      //App.models.plant = new Plant(App.models.plant);

    } else {
      if (data === false) {
        info("data Not Found... skipping deetMerge");
      } else {
        info("data nid mismatch", data, App.models.plant.get("nid"));
      }
    }

    if (App.models.plant.sun_exposure) {
      //info(App.models.plant.sun_exposure);
      App.models.plant.sun = App.models.plant.sun_exposure.split('|');
      //info(App.models.plant.sun);
    }

    // if (App.models.plant.water_cat) {

    // }

    if (App.models.plant.height) {
      // convert "25.0-25.0" to "25"
      App.models.plant.height = this.getValFromRange(App.models.plant.height);
    }

    if (App.models.plant.width) {
      App.models.plant.width = this.getValFromRange(App.models.plant.width);
    }


    // additional_images
    // info("additional_images",App.models.plant.additional_images);

    // include warning
    if (App.models.plant.warning) {
      // convert "25.0-25.0" to "25"
      App.models.plant.plant_warning = App.models.plant.warning;
    }


    info("update share model");
    // shareUrl="http://desertlandscaping.arizona.edu/plants/?name=#= Utils.changeSpacesToDashes(common_name) #&id=#= nid #&share=plant" 
    // shareTitle="#= common_name # :: Plants :: Desert Landscaping :: Arizona.edu"
    // if (App.models.plant.shareUrl) {
    App.shareUrl = "plants/"
      + "?name=" + Utils.changeSpacesToDashes(App.models.plant.get("common_name"))
      + "&id=" + App.models.plant.get("nid")
      + "&share=plant";
    App.models.plant.shareUrl = App.config.prodPath + App.shareUrl;
    // } else {
    //     App.models.plant.shareUrl = "http://desertlandscaping.arizona.edu/plants/";
    // }

    // if (App.models.plant.shareTitle) {
    App.gaTitle = App.models.plant.get("common_name") + " :: Plants :: Desert Landscaping :: Arizona.edu";
    App.models.plant.shareTitle = App.gaTitle;
    // } else {
    //     App.models.plant.shareTitle = "Plants :: Desert Landscaping :: Arizona.edu";
    // }

    return data;
  }

  public getValFromRange(val) {
    //info(App.models.plant.width);
    let aRange = val.split('-');

    if (aRange && aRange.length > 1) {
      if (aRange[0] === aRange[1]) {
        val = aRange[0];
      }
    }

    //info(App.models.plant.width);
    return val.replace(/\.0+/g, '');
  }

  public loadRenderTpl = (data) => {
    groupCollapsed("Plant.Render");
    log("loadRenderTpl");
    if ($(this.container).length) {
      log("ready for plant tpl");
      this.loadTpl(this.renderTpl);
    } else {
      $(() => {
        log("plant dom ready!");
        if (typeof this.loadTpl === "function" && typeof this.renderTpl === "function") {
          this.loadTpl(this.renderTpl);
        }

      });
    }
    groupEnd("Plant.Render");
  }


  public loadTpl(callback) {
    log("Plant > loadTpl", this);
    if ($("#" + this.tplSel).length) {
      info("// we already have the tpl");
      this.renderTpl({ sel: this.container, tag: this.tplSel });
    } else {
      App.templates.loadLayout(this.page, this.tplSel, this.renderTpl, App.models.plant);
    }

  }

  public renderTpl(resp) {
    log("Plant > renderTpl resp: %o", resp);
    if (resp && resp.sel && $(resp.sel).length) {
      //log($(resp.sel));
      let options: any = (App.models.plant) ? { model: App.models.plant, evalTemplate: true } : { evalTemplate: true };
      info("Plant Model: %o", App.models.plant);

      // 2019-01-08
      // fix template bugs with removing/encoding '+' and gt and lt
      options.model._for_increment = (i) => i + 1;
      options.model._for_lessthan = (i, j) => i < j;
      options.model._if_greaterthan = (i, j) => i > j;
      options.model._if_and = (i, j) => i && j;

      // options.model.img_url = App.config.img_url.plant;
      log("options: %o", options);
      App.views.plant = new kendo.View($('#' + resp.tag).html(), options);
      //$(resp.sel + " .loader-wrap").remove();
      $(resp.sel).empty();
      App.views.plant.render($(resp.sel));

      //App.models.plant.set("nid","no");

      App.content.Plant.createImageGallery();

      App.content.Plant.addEvents();

      if (this.returnUrl && $("#plant_btm_nav").length) {
        log("this is an idea, only back");
        $(".action__previous").hide();
        $(".action__next").hide();
      }

      Utils.smoothScrollTo('top');

      let refreshAddThis = function () {
        AddThis.refresh();//{ sel: '.addthis_plant_sharing_toolbox'});
        AddThis.update();
      };
      window.setTimeout(refreshAddThis, 1000);
      // refreshAddThis();


    } else {
      info("no sel?");
    }

  }

  public createImageGallery() {
    //http://idangero.us/swiper
    this.plantSwiper = new Swiper(this.gallerySel, {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      autoHeight: true,//Set to true and slider wrapper will adopt its height to the height of the currently active slide

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      //enable hash navigation
      //hashnav: true // messes with hash routing...

      //And if we need scrollbar
      //scrollbar: '.swiper-scrollbar',
    });
    // App.ideaSwiper.update();

    //  add callback
    // App.plantSwiper.on('slideChangeStart', function (swiper) {
    //     // per API: Note, that in loop mode active index value will be always shifted on a number of looped/duplicated slides

    //     //info(typeof swiper.activeIndex);
    //     if (swiper && typeof swiper.activeIndex === "number") {
    //         //info('swiper slideChangeStart > activeIndex:', swiper.activeIndex, swiper);
    //         let newNum = swiper.activeIndex + 1;
    //         App.router.navigate("/ideas/" + newNum, true);//silent
    //         App.shareUrl = 'ideas/?share=' + 'ideas' + "&loc=" + (swiper.activeIndex + 1);
    //         App.Controller.updateShareVars("Desert Landscaping :: Ideas Gallery Item " + newNum, { loc: newNum });
    //     }
    // });
  }

  public changePlant(plant) {
    if (plant && plant.nid) {
      let name = plant.common_name;
      info("changePlant nid:", plant.nid);
      this.nid = plant.nid;
      App.models.plant = plant;
      // this.renderTpl({sel:this.tplSel});
      // if (App.plants.pager && typeof App.plants.pager.destroy === "function") {
      //     App.plants.pager.destroy();
      // } else {
      //     info("no pager found = no destroy");
      // }
      // if (App.plants.listView && typeof App.plants.listView.destroy === "function") {
      //     App.plants.listView.destroy();
      // } else {
      //     info("no listView found = no destroy");
      // }
      //App.plants.destroyPager();



      App.router.navigate("/plant/" + plant.nid + "/" + Utils.changeSpacesToDashes(plant.common_name));
    } else {
      info("!plant || !plant.nid");
    }
  }

  public addEvents() {
    // action__share
    // action__print
    // action__basket
    // action__previous
    // action__next   
    // action__back

    let sel = '.action__share';
    if ($(sel).length) {
      $(sel).off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        let nav = $(this).attr('href');
        log("click", nav, $(this));
        // if (nav && window.history && window.history.pushState) {
        //     var stateObj = { nav: nav };
        //     window.history.pushState(stateObj, "Tips : " + tab + "Desert Landscaping ", nav);
        // }
      });
    }

    sel = '.action__print';
    if ($(sel).length) {
      $(sel).off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        let nav = $(this).attr('href');
        log("click", nav, $(this));
      });
    }

    sel = '.action__basket';
    if ($(sel).length) {
      $(sel).off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        let nav = $(this).attr('href');
        log("click", nav, $(this));
      });
    }

    let navByNid = this.navByNid;

    sel = '.action__previous';
    if ($(sel).length) {
      $(sel).off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        // var nav = $(this).attr('href');
        let nid = $(this).attr('data-curid');
        log("click prev - current nid = ", nid);//, $(this));
        navByNid("prev", nid);
      });
    }

    sel = '.action__next';
    if ($(sel).length) {
      $(sel).off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        //var nav = $(this).attr('href');
        let nid = $(this).attr('data-curid');
        log("click next - current nid = ", nid);//, $(this));
        navByNid("next", nid);
      });
    }

    let returnUrl = this.returnUrl;

    sel = '.action__back';
    if ($(sel).length) {
      $(sel).off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        let nav = $(this).attr('href');
        log("click back", nav);//, $(this));
        if (returnUrl) {
          App.router.navigate("/" + returnUrl);
        } else {
          App.router.navigate("/plants");
        }
      });
    }
  }


  public navByNid = (dir, nid) => {
    // get filters from Plant Selector for navigation
    let selFilter = null;
    info("navByNid > Plants.datasource:", App.plants.datasource);
    if (App.plants.datasource && typeof App.plants.datasource.filter === "function") {
      selFilter = App.plants.datasource.filter();
      //log("get current filter:",filter);
      if (selFilter && selFilter.filters) {
        info("navByNid > selFilter.filters:", selFilter);
      } else {
        log("navByNid > no current plant selector filters");
        selFilter = null;
      }
    } else {
      log("navByNid > no current plant selector datasource");
    }


    let dataSource = this.datasource,
      curPlant = App.models.plant;
    //log("Plant model: %o",curPlant);
    //info("dataSource",dataSource);
    let filter = dataSource.filter();
    //log("filters set: ",filter); 

    // v3 - remove nid filter in all cases
    if (selFilter) {
      info("use plant selector datasource filters");
      // Shallow copy
      filter = jQuery.extend({}, selFilter);
      info("cloned filter:", filter);
    } 
    if (filter && filter.filters && filter.filters.length) {
      log("// remove the filter for eq nid, leave others...", filter.filters);
      for (let i = filter.filters.length - 1; i >= 0; i--) {
        if (filter.filters[i].field && filter.filters[i].field === "nid") {
          log("splicing nid filter");
          filter.filters.splice(i, 1);
        }
      }
      log("filters after nid scrub:", filter);
    }

    // v2 -use plant selector datasource or erase all filters
    // if (selFilter) {
    //   info("use plant selector datasource filters");
    //   // Shallow copy
    //   //var newObject = jQuery.extend({}, oldObject);
    //   // Deep copy
    //   //var newObject = jQuery.extend(true, {}, oldObject);
    //   filter = jQuery.extend({}, selFilter);
    //   info("cloned filter:", filter);
    // } else {
    //   // v1 - could just send in a new obj{} to reset ?
    //   if (filter && filter.filters && filter.filters.length) {
    //     log("// remove the filter for eq nid, leave others...", filter.filters);
    //     for (let i = filter.filters.length - 1; i >= 0; i--) {
    //       if (filter.filters[i].field && filter.filters[i].field === "nid") {
    //         log("splicing nid filter");
    //         filter.filters.splice(i, 1);
    //       }
    //     }
    //     log("filters after nid scrub:", filter);
    //   }
    // }



    let sort = dataSource.sort();
    if (!sort || sort.length < 1) {
      sort = {};
    } else {
      sort = sort[0];
    }
    log("sort:", sort);

    // avoid Kendo Error: Uncaught Error: Cannot call method 'value' of kendoDropDownList before it is initialized
    App.plants.destroyPager();
    
    info(dataSource);
    // dataSource.pageSize(1);
    // info(dataSource);
    // dataSource.page(1);
    // info(dataSource);

    dataSource.query({
      // page: 1,
      // pageable: {
      //     pageSize: 1
      sort,
      filter //{} = reset
    }).then(function (e) {
      log("HERE");
      let view = dataSource.view(),
        index = view.indexOf(curPlant),
        getIndex = 0;
      log("sorted indexOf", index);
      log("sorted length", view.length);

      // index will be -1 if not found...

      switch (dir) {
        case "next":
          if (index >= 0 && index + 1 < view.length) {
            getIndex = index + 1;
          } else {
            getIndex = 0;
          }
          break;
        case "prev":
          if (index > 0) {
            getIndex = index - 1;
          } else {
            getIndex = view.length - 1;
          }
          break;
      }

      log("get ", getIndex);

      let newPlant = view.at(getIndex);

      log("newPlant:", newPlant);

      App.content.Plant.changePlant(newPlant);

    });
  }





}
